  <!-- 车辆配载 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore" />

    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" @selectChange="handleSelectionChange" @rowCallback="rowCallback" ref="mytable" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />
    <!-- 车辆档案新增弹窗 -->
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="diaCancelBtn" @diaConfirmBtn="diaConfirmBtn">
      <div class="el-dialog-div" v-if="isShowDialog">
        <table-plug :tableConfig="tableConfig_dia" :totals="totalArr_dia" :defaulthead="myTableHeard_dia" ref="mytable_dia" />
        <!-- 分页 -->
        <paging ref="pags" :pageNum="pageStart_dia" :total="pageCount_dia" :size="pageTotal_dia" @handleSizeChange="handleSizeChange_dia" @handleCurrentChange="handleCurrentChange_dia" />
      </div>
    </my-dialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true" />
    </exportCompoent>
  </div>
</template>
 <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "车辆配载", //导出时默认文件名
        apiName: "/admin/v3/tms/report/getCarLoadProfitList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "导出",
          method: "exportData",
          permissVal: "aaaaa",
        },
        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "打印",
          method: "printData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "input",
          label: "车牌号",
          field: "carNumber",
          placeholder: "请输入",
        },
      ],

      queryData: {
        carNumber: null,
      },

      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "操作",
          field: "edit",
          width: 120,
          Buttons: [
            {
              method: "Details",
              methodName: "详情",
            },
          ],
        },
        {
          name: "车牌号",
          field: "carNumber",
          sort: 3,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "可载重量",
          field: "loadableCapacity",
          sort: 4,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },

        {
          name: "可载体积",
          field: "loadableVolume",
          sort: 5,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "当前装载总重量",
          field: "currentWeight",
          sort: 6,
          isShow: true,
          width: "160",
          isTotal: false,
          isSort: false,
        },
        {
          name: "当前装载总体积",
          field: "currentVolume",
          sort: 1,
          isShow: true,
          width: "160",
          isTotal: false,
          isSort: false,
        },
        {
          name: "分配装载总重量",
          field: "totalWeight",
          sort: 1,
          isShow: true,
          width: "160",
          isTotal: false,
          isSort: false,
        },
        {
          name: "分配装载总体积",
          field: "totalVolume",
          sort: 18,
          isShow: true,
          width: "160",
          isTotal: false,
          isSort: false,
        },
      ],
      sortName: "车辆配载", //  排序名
      pageGroupName: "VehicleStowage",
      // 详情弹窗
      diaWidth: "60%",
      dialogTitle: "详情",
      isShowDialog: false,
      tableConfig_dia: {
        tableHeigth: "60vh",
        tableData: [],
      },
      totalArr_dia: [],
      myTableHeard_dia: [
        // {
        //   name: "操作",
        //   field: "edit",
        //   width: 120,
        //   Buttons: [
        //     {
        //       method: "Details",
        //       methodName: "详情",
        //     },
        //   ],
        // },
        {
          name: "任务编号",
          field: "number",
          sort: 3,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "运单号",
          field: "waybillNumber",
          sort: 4,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },

        {
          name: "任务运输方式",
          field: "transportMethodShow",
          sort: 5,
          isShow: true,
          width: "160",
          isTotal: false,
          isSort: false,
        },
        {
          name: "运输计划",
          field: "transportPlanShow",
          sort: 6,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "提货单号",
          field: "takeAddrNumber",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "状态",
          field: "aaaaa",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "货物",
          field: "aaaaa",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },

        {
          name: "客户单号",
          field: "customerOrderNumber",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "客户名称",
          field: "customerName",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "客户编号",
          field: "customerNumber",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "入仓仓库",
          field: "intoStorageName",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "外部运输承运商",
          field: "carrierName",
          sort: 18,
          isShow: true,
          width: "160",
          isTotal: false,
          isSort: false,
        },
        {
          name: "外发承运商",
          field: "outgoingCarrierName",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "外发承运商网点",
          field: "outgoingDeptName",
          sort: 18,
          isShow: true,
          width: "160",
          isTotal: false,
          isSort: false,
        },
        {
          name: "提货时间",
          field: "takeTime",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "交货日期",
          field: "deliveryTime",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "装货地址",
          field: "taskStartAllAddress",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "卸货地址",
          field: "taskEndAllAddress",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "发车批次号",
          field: "dispatchNumber",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "车牌号",
          field: "carNumber",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "挂车号码",
          field: "trailerNumber",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "司机",
          field: "driverName",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "押运员",
          field: "supercargoName",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "发车合同号",
          field: "dispatchContractNumber",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "创建人",
          field: "createUserName",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "创建时间",
          field: "createTime",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "装货时间",
          field: "loadTime",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "装货操作人",
          field: "loadUserName",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "卸货时间",
          field: "unloadTime",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "卸货操作人",
          field: "unloadUserName",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "是否退单",
          field: "chargebackStatusShow",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "退单原因",
          field: "chargebackReason",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "是否回仓",
          field: "returnCangStatusShow",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "回仓原因",
          field: "returnCangReason",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "回仓仓库",
          field: "returnCangStorageName",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
      ],
      pageStart_dia: 1,
      pageCount_dia: 0,
      pageTotal_dia: 20,
      carNumber: null,
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.GetData();
  },
  methods: {
    // 获取车辆配载
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.$API.CarLoadProfitList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---车辆配载`);
        }
      });
    },
    // 获取详情
    GetTaskList() {
      this.$API.wtl_getTaskList({ carNumber: this.carNumber }).then((res) => {
        if (res.data.status === "success") {
          this.tableConfig_dia.tableData = res.data.result.data || [];
          this.pageCount_dia = res.data.result.pageCount || 0;
        } else {
          this.$message.error(`${res.data.message}`);
        }
      });
    },
    Details(e) {
      this.carNumber = e.carNumber;
      this.GetTaskList();
      this.isShowDialog = true;
    },

    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.carNumber = null;
      this.isShowDialog = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.diaConfirmBtn();
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.diaConfirmBtn();
    },
    handleSizeChange_dia(e) {
      this.pageTotal_dia = e;
      this.GetTaskList();
    },
    handleCurrentChange_dia(e) {
      this.pageStart_dia = e;
      this.GetTaskList();
    },

    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },
    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data);
    },
    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.GetData();
    },
    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 导出
    exportData() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },
    // 表格设置
    SetTable() {},
    // 打印
    printData() {},
  },
};
</script>
<style scoped lang="less">
.el-dialog-div {
  height: 66vh; //如果高度过高，可用max-height
  overflow: auto;
}
/deep/.el-dialog__body {
  padding: 0 15px;
}
</style>
                            